import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-aos": "fade-in" }
const _hoisted_2 = { class: "pt-3" }

import { computed, onMounted, onUnmounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const animate = ref(true);
const maxDotsCount = ref(10);
const minDotsCount = ref(0);
const dotsCount = ref(0);

const dots = computed(() => {
  let text = "";
  for (let i = 0; i < dotsCount.value; i++) {
    text += ".";
  }
  return text;
});
onUnmounted(() => (animate.value = false));

onMounted(() => loadingAnimation());
async function loadingAnimation() {
  while (animate.value) {
    await new Promise((resolve) => setTimeout(resolve, 300)); // 0.5 sec
    dotsCount.value++;
    if (dotsCount.value > maxDotsCount.value)
      dotsCount.value = minDotsCount.value;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_font_awesome_icon, {
      class: "text-palette1 animate-spin mx-auto",
      icon: "spinner",
      size: "lg"
    }),
    _createElementVNode("p", _hoisted_2, "wait" + _toDisplayString(_unref(dots)), 1)
  ]))
}
}

})